import React from "react";
import { connect } from "react-redux";
import BrokerDealsContainer from "./BrokerDealsContainer";
import CorporateDataDealsContainer from "./CorporateDataDealsContainer";
import DataAdminDealsContainer from "./DataAdminDealsContainer";

const DealsContainer = (props) => {
    const { history, location, role, user } = props;
    switch (role) {
        case "broker": {
            return <BrokerDealsContainer history={history} user={user} role={role} />;
        }
        case "debtEquity": {
            return <BrokerDealsContainer history={history} user={user} role={role} />;
        }
        case "evp": {
            return <BrokerDealsContainer history={history} user={user} role={role} />;
        }
        case "portlandBrokerAdmin": {
            return <BrokerDealsContainer history={history} user={user} role={role} />;
        }
        case "arizonaBrokerAdmin": {
            return <BrokerDealsContainer history={history} user={user} role={role} />;
        }
        case "dataEntry": {
            return <CorporateDataDealsContainer history={history} location={location} user={user} />;
        }
        case "dataAdmin": {
            return <DataAdminDealsContainer history={history} user={user} />;
        }
        default: {
            return null;
        }
    }
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
    };
};

export default connect(mapStateToProps)(DealsContainer);
